import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import Reimburesement from '@/types/table/reimburesement';
import { ReimburesementDetailData } from '@/api/generated/reimburesementDetailController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ReimburesementData extends Reimburesement {
  reimburesementDetailList?: ReimburesementDetailData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ReimburesementController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ReimburesementData>>(API_CONTEXT + '/upms/reimburesement/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ReimburesementData>(API_CONTEXT + '/upms/reimburesement/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/reimburesement/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/reimburesement/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/reimburesement/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowReimbursement(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/startOnly/flowReimbursement', params, httpOptions);
  }
  static startWithBusinessKeyFlowReimbursement(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/startWithBusinessKey/flowReimbursement', params, httpOptions);
  }
  static startAndTakeUserTaskFlowReimbursement(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/startAndTakeUserTask/flowReimbursement', params, httpOptions);
  }
  static startAndSaveDraftFlowReimbursement(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/startAndSaveDraft/flowReimbursement', params, httpOptions);
  }
  static submitUserTaskFlowReimbursement(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/submitUserTask/flowReimbursement', params, httpOptions);
  }
  static viewTaskBusinessDataFlowReimbursement(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/reimburesement/viewTaskBusinessData/flowReimbursement', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataFlowReimbursement(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/reimburesement/viewHistoricTaskBusinessData/flowReimbursement', params, httpOptions);
  }
  static listWorkOrderFlowReimbursement(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/reimburesement/listWorkOrder/flowReimbursement', params, httpOptions);
  }
}
